import { j as t } from "./atoms-v218.js";
import { InputInterior as o } from "./atoms-v221.js";
const i = ({ children: r }) => /* @__PURE__ */ t.jsx(o, { children: r });
export {
  i as InputInterior
};
